// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/img/footer-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
.footer {
  padding: 0 0 50px 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

.footer img {
  padding-top: 30px;
  width: 26%;
}

.footer p {
  font-weight: 400;
  font-size: 14px;
  color: #b8b8b8;
  letter-spacing: 0.5px;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./packages/studytour-io-app/src/components/Footer.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,mBAAmB;EACnB,yDAAoD;EACpD,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":["/**\n * Copyright 2025 Paion Data. All rights reserved.\n */\n.footer {\n  padding: 0 0 50px 0;\n  background-image: url(\"../assets/img/footer-bg.png\");\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.footer img {\n  padding-top: 30px;\n  width: 26%;\n}\n\n.footer p {\n  font-weight: 400;\n  font-size: 14px;\n  color: #b8b8b8;\n  letter-spacing: 0.5px;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
